import selector from 'modules/Auth/selectors'
import corporateRequest from 'utils/corporateRequest'
import instituteRequest from 'utils/instituteRequest'
import studentRequest from 'utils/studentRequest'
export const CITY_FILTER = 'report/CITY_FILTER'
export const TIER_FILTER = 'report/TIER_FILTER'
export const ROLE_PUBLISHED = 'report/ROLE_PUBLISHED'
export const CANDIDATE_APPLICATION_STATUS = `report/CANDIDATE_APPLICATION_STATUS`
export const ROLE_FILTER = 'report/ROLE_FILTER'
export const COLLEGE_FILTER = 'report/COLLEGE_FILTER'
export const APPLICATION_DRIVE_LEVEL = `report/APPLICATION_DRIVE_LEVEL`
export const ROUND = 'report/roundFilter'
export const COURSE_TYPE = 'report/courseType'
export const HIRING_LEVEL = 'report/HIRING_LEVEL'
export const DEGREE_DEPARTMENT_FILTER = `report/degDepFilter`
export const INTERVIEW_SCHEDULE = `report/INTERVIEW_SCHEDULE`
export const SET_EXCEL_DATA = `corp/EXCEL`
export const STUDENT_DETAILS = 'report/student/details'
export const STUDENT_STATUS = `report/student/status`

export const setCityData = data => {
  return {
    type: CITY_FILTER,
    data,
  }
}
export const setStatus = data => {
  return {
    type: STUDENT_STATUS,
    data,
  }
}
export const setStudentData = data => {
  return {
    type: STUDENT_DETAILS,
    data,
  }
}
export const setDegDepData = data => {
  return {
    type: DEGREE_DEPARTMENT_FILTER,
    data,
  }
}
export const setTierData = data => {
  return {
    type: TIER_FILTER,
    data,
  }
}

export const setRoleData = data => {
  return {
    type: ROLE_FILTER,
    data,
  }
}
export const setCollegeData = data => {
  return {
    type: COLLEGE_FILTER,
    data,
  }
}

export const setRolePublished = data => {
  return {
    type: ROLE_PUBLISHED,
    data,
  }
}
export const setCandidateApplicationStatus = data => {
  return {
    type: CANDIDATE_APPLICATION_STATUS,
    data,
  }
}
export const setExcelData = data => {
  return {
    type: SET_EXCEL_DATA,
    data,
  }
}
export const setApplicationDriveLeve = data => {
  return {
    type: APPLICATION_DRIVE_LEVEL,
    data,
  }
}
export const setRoundData = data => {
  return {
    type: ROUND,
    data,
  }
}
export const setCourseTypeData = data => {
  return {
    type: COURSE_TYPE,
    data,
  }
}
export const setHiringLevel = data => {
  return {
    type: HIRING_LEVEL,
    data,
  }
}
export const setInterviewSchedule = data => {
  return {
    type: INTERVIEW_SCHEDULE,
    data,
  }
}
export const degreeDetails =
  (setLoading, search, setDegreeLoader, page = 0) =>
  async (dispatch, getState) => {
    try {
      if (page == 0) {
        setLoading(true)
      }
      setDegreeLoader(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `?corpid=${corporateId}`
      const Search = search ? `&name=${search}` : ``
      let response = await corporateRequest.get(
        `/degreedepartmentreport/lists${Corp}&size=2&page=${page}${Search}`
      )
      dispatch(setDegDepData(response?.data?.data))
      setLoading(false)
      setDegreeLoader(false)
    } catch (error) {
      setDegreeLoader(false)
      setLoading(false)
    }
  }
export const studentDetaisl = (setLoading, id) => async dispatch => {
  try {
    setLoading(true)
    let response = await instituteRequest.get(`/institutes/crud/degree/dept`)
    dispatch(setDegDepData(response?.data?.data))
    setLoading(false)
  } catch (error) {
    setLoading(false)
  }
}
export const studentDetails =
  (setLoading, id) => async (dispatch, getState) => {
    try {
      setLoading(true)
      const response = await studentRequest.get(`/students/${id}`)

      dispatch(setStudentData(response.data.data))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

export const statusDetails =
  (setLoading, type, page, setLoad) => async (dispatch, getState) => {
    try {
      if (page == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `?corpid=${corporateId}`
      const Type = type ? `&status=${type?.toLowerCase()}` : ``
      let response = await corporateRequest.get(
        `/interviewstatusroundmaster/lists${Corp}${Type}&page=${page}`
      )
      dispatch(setStatus(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const roundDetails =
  (setLoading, type, page, setLoad) => async (dispatch, getState) => {
    try {
      if (page == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `?corpid=${corporateId}`
      const Type = type ? `&round=${type?.toLowerCase()}` : ``
      let response = await corporateRequest.get(
        `/interviewroundmaster/lists${Corp}${Type}&page=${page}`
      )
      dispatch(setRoundData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const courseTypeDetails =
  (setLoading, type, page, setLoad) => async (dispatch, getState) => {
    try {
      if (page == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `?corpid=${corporateId}`
      const Type = type ? `&course=${type?.toLowerCase()}` : ``
      let response = await corporateRequest.get(
        `/coursetypemaster/lists${Corp}${Type}&page=${page}`
      )
      dispatch(setCourseTypeData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const cityDetails =
  (setLoading, city, flag, page, setLoad) => async (dispatch, getState) => {
    try {
      let pageNumber = page || 0
      if (pageNumber == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `&corpid=${corporateId}`
      const City = city ? `&city=${city?.toLowerCase()}` : ``
      const Flag = flag ? `&flag=${flag}` : ``

      let response = await corporateRequest.get(
        `/cityrolecorporatesmaster/lists?page=${pageNumber}${Corp}${City}${Flag}`
      )
      dispatch(setCityData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }

export const tierDetails =
  (setLoading, tier, flag, page, setLoad) => async (dispatch, getState) => {
    try {
      let pageNumber = page || 0
      if (pageNumber == 0) {
        setLoading(true)
      }

      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `?corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      const Flag = flag ? `&flag=${flag}` : ``
      let response = await corporateRequest.get(
        `/tiercorporatesfilter/lists${Corp}${Tier}${Flag}&page=${pageNumber}`
      )
      dispatch(setTierData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const collegeDetails =
  (setLoading, tier, flag, page, setLoad) => async (dispatch, getState) => {
    try {
      let pageNumber = page || 0
      if (pageNumber == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `&corpid=${corporateId}`
      const Flag = flag ? `&flag=${flag}` : ``

      const Tier = tier ? `&name=${tier?.toLowerCase()}` : ``
      let response = await corporateRequest.get(
        `/collegenamecorporatesfilter/lists?page=${pageNumber}&size=10${Tier}${Corp}${Flag}`
      )
      dispatch(setCollegeData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const roleDetails =
  (setLoading, tier, flag, page, setLoad) => async (dispatch, getState) => {
    dispatch(setRoleData({}))
    let pageNumber = page || 0
    try {
      if (pageNumber == 0) {
        setLoading(true)
      }
      setLoad(true)
      const state = getState()
      const corporateId = selector.getCorporateId(state)
      const Corp = `&corpid=${corporateId}`
      const Flag = flag ? `&flag=${flag}` : ``
      const Tier = tier ? `&role=${tier?.toLowerCase()}` : ``
      let response = await corporateRequest.get(
        `/rolecorporatesfilter/lists?page=${pageNumber}&size=10${Tier}${Corp}${Flag}`
      )
      dispatch(setRoleData(response?.data?.data))
      setLoading(false)
      setLoad(false)
    } catch (error) {
      setLoading(false)
      setLoad(false)
    }
  }
export const getRolePublishedToCollege =
  (
    pageSize,
    pageNumber,
    setLoadingRole,
    searchRoleValue,
    filterDatas,
    sortBy,
    excel = false
  ) =>
  async (dispatch, getState) => {
    const state = getState()
    if (setLoadingRole) {
      setLoadingRole(true)
    }
    const corporateId = selector.getCorporateId(state)
    dispatch(setExcelData([]))
    let BASE_URL = 'corporates-reports/rolepublishtocollege/lists'
    try {
      let tier = encodeURIComponent(filterDatas?.tier || '')
      let city = encodeURIComponent(filterDatas?.city || '')
      const Corp = `&corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      let createdAtEnd = filterDatas?.createdAtEnd || ''
      let createdAtStart = filterDatas?.createdAtStart || ''
      const City = city ? `&city=${city}` : ``
      const Search = searchRoleValue
        ? `&role=${searchRoleValue?.toLocaleLowerCase()}`
        : ``
      const CreatedAtStart = createdAtStart
        ? `&createdAtStart=${createdAtStart}`
        : ``
      const CreatedAtEnd = createdAtEnd ? `&createdAtEnd=${createdAtEnd}` : ``
      const Sort = sortBy?.sortName ? `&sort=${sortBy.sortName}` : ``
      const OrderBy = sortBy?.orderBy ? `&orderBy=${sortBy.orderBy}` : ``
      const response = await corporateRequest.get(
        `${BASE_URL}?size=${pageSize}&page=${
          pageNumber - 1
        }${Search}${Tier}${City}${Sort}${OrderBy}${Corp}${CreatedAtStart}${CreatedAtEnd}`
      )
      if (excel) {
        dispatch(setExcelData(response?.data?.data || []))
      } else {
        dispatch(setRolePublished(response?.data?.data || []))
      }

      if (setLoadingRole) setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        dispatch(setExcelData([]))
        setLoadingRole(false)
      }
    }
  }

export const getCandidateApplicationStatus =
  (
    pageSize,
    pageNumber,
    setLoadingRole,
    searchRoleValue,
    filterDatas,
    sortBy,
    excel = false
  ) =>
  async (dispatch, getState) => {
    const state = getState()
    if (setLoadingRole) {
      setLoadingRole(true)
    }
    const corporateId = selector.getCorporateId(state)
    dispatch(setExcelData([]))
    let BASE_URL = '/corporates-reports/candidateappstatus/lists'
    try {
      let tier = encodeURIComponent(filterDatas?.tier || '')
      let city = encodeURIComponent(filterDatas?.city || '')
      let college = encodeURIComponent(filterDatas?.college || '')
      let role = encodeURIComponent(filterDatas?.role || '')
      let offered = encodeURIComponent(filterDatas?.offered || '')
      let accepted = encodeURIComponent(filterDatas?.accepted || '')
      let createdAtEnd = filterDatas?.createdAtEnd || ''
      let createdAtStart = filterDatas?.createdAtStart || ''
      let appenddate = filterDatas?.appenddate || ''
      const Corp = `&corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      const City = city ? `&city=${city}` : ``
      const Offered = offered ? `&offered=${offered}` : ``
      const Accepted = accepted ? `&accepted=${accepted}` : ``
      const College = college ? `&college=${college}` : ``
      const Role = role ? `&role=${role}` : ``
      const Search = searchRoleValue
        ? `&rolename=${searchRoleValue?.toLocaleLowerCase()}`
        : ``
      const CreatedAtEnd = createdAtEnd ? `&createdAtEnd=${createdAtEnd}` : ``
      const AppendDate = appenddate ? `&appenddate=${appenddate}` : ``
      const CreatedAtStart = createdAtStart
        ? `&createdAtStart=${createdAtStart}`
        : ``
      const Sort = sortBy?.sortName ? `&sort=${sortBy.sortName}` : ``
      const OrderBy = sortBy?.orderBy ? `&orderBy=${sortBy.orderBy}` : ``
      const response = await corporateRequest.get(
        `${BASE_URL}?size=${pageSize}&page=${
          pageNumber - 1
        }${Search}${Tier}${City}${Sort}${OrderBy}${Corp}${Role}${College}${Offered}${Accepted}${CreatedAtStart}${CreatedAtEnd}${AppendDate}`
      )
      if (excel) {
        dispatch(setExcelData(response?.data?.data || []))
      } else {
        dispatch(setCandidateApplicationStatus(response?.data?.data || []))
      }

      if (setLoadingRole) setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        dispatch(setExcelData([]))
        setLoadingRole(false)
      }
    }
  }
export const getApplicationDriveLevel =
  (
    pageSize,
    pageNumber,
    setLoadingRole,
    searchRoleValue,
    filterDatas,
    sortBy,
    excel = false
  ) =>
  async (dispatch, getState) => {
    const state = getState()
    if (setLoadingRole) {
      setLoadingRole(true)
    }
    const corporateId = selector.getCorporateId(state)
    dispatch(setExcelData([]))
    let BASE_URL = '/corporates-reports/applicationdrivelevel/lists'

    try {
      let tier = encodeURIComponent(filterDatas?.tier || '')
      let city = encodeURIComponent(filterDatas?.city || '')
      let college = encodeURIComponent(filterDatas?.college || '')
      let role = encodeURIComponent(filterDatas?.role || '')
      let offered = encodeURIComponent(filterDatas?.offered || '')
      let accepted = encodeURIComponent(filterDatas?.accepted || '')
      let round = encodeURIComponent(filterDatas?.round || '')
      let status = encodeURIComponent(filterDatas?.status || '')
      let type = encodeURIComponent(filterDatas?.type || '')
      let degree = encodeURIComponent(filterDatas?.degreeStreamMapId || '')
      let createdAtEnd = filterDatas?.createdAtEnd || ''
      let createdAtStart = filterDatas?.createdAtStart || ''
      let appenddate = filterDatas?.appenddate || ''
      const Corp = `&corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      const City = city ? `&city=${city}` : ``
      const Offered = offered ? `&offered=${offered}` : ``
      const Accepted = accepted ? `&accepted=${accepted}` : ``
      const College = college ? `&college=${college}` : ``
      const Role = role ? `&role=${role}` : ``
      const Round = round ? `&round=${round}` : ``
      const Status = status ? `&status=${status}` : ``
      const Type = type ? `&course=${type}` : ``
      const Degree = degree ? `&degreestreammapid=${degree}` : ``
      const Rank = filterDatas?.rank ? `&rank=${filterDatas?.rank}` : ``
      const RankSign = filterDatas?.rankSign
        ? `&ranksign=${decodeURIComponent(filterDatas?.rankSign)}`
        : ``
      const Search = searchRoleValue
        ? `&rolename=${searchRoleValue?.toLocaleLowerCase()}`
        : ``
      const CreatedAtEnd = createdAtEnd ? `&createdAtEnd=${createdAtEnd}` : ``
      const AppendDate = appenddate ? `&appenddate=${appenddate}` : ``
      const CreatedAtStart = createdAtStart
        ? `&createdAtStart=${createdAtStart}`
        : ``
      const Sort = sortBy?.sortName ? `&sort=${sortBy.sortName}` : ``
      const OrderBy = sortBy?.orderBy ? `&orderBy=${sortBy.orderBy}` : ``
      const response = await corporateRequest.get(
        `${BASE_URL}?size=${pageSize}&page=${
          pageNumber - 1
        }${Search}${Round}${Status}${Degree}${Type}${Tier}${City}${Sort}${OrderBy}${Corp}${Role}${College}${Offered}${Accepted}${CreatedAtStart}${CreatedAtEnd}${AppendDate}${Rank}${RankSign}`
      )
      if (excel) {
        dispatch(setExcelData(response?.data?.data || []))
      } else {
        dispatch(setApplicationDriveLeve(response?.data?.data || []))
      }

      if (setLoadingRole) setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        dispatch(setExcelData([]))
        setLoadingRole(false)
      }
    }
  }

export const hiringLevelDetails =
  (
    pageSize,
    pageNumber,
    setLoadingRole,
    searchRoleValue,
    filterDatas,
    sortBy,
    excel = false
  ) =>
  async (dispatch, getState) => {
    const state = getState()
    if (setLoadingRole) {
      setLoadingRole(true)
    }
    const corporateId = selector.getCorporateId(state)
    dispatch(setExcelData([]))
    let BASE_URL = 'corporates-reports/rolewisehiringstatus/lists'
    try {
      let tier = encodeURIComponent(filterDatas?.tier || '')
      let city = encodeURIComponent(filterDatas?.city || '')
      let college = encodeURIComponent(filterDatas?.college || '')
      let role = encodeURIComponent(filterDatas?.role || '')
      let offered = encodeURIComponent(filterDatas?.offered || '')
      let accepted = encodeURIComponent(filterDatas?.accepted || '')
      let round = encodeURIComponent(filterDatas?.round || '')
      let type = encodeURIComponent(filterDatas?.type || '')
      let createdAtEnd = filterDatas?.createdAtEnd || ''
      let createdAtStart = filterDatas?.createdAtStart || ''
      let appenddate = filterDatas?.appenddate || ''
      const Corp = `&corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      const City = city ? `&city=${city}` : ``
      const Offered = offered ? `&offered=${offered}` : ``
      const Accepted = accepted ? `&accepted=${accepted}` : ``
      const College = college ? `&college=${college}` : ``
      const Role = role ? `&role=${role}` : ``
      const Round = round ? `&round=${round}` : ``
      const Type = type ? `&course=${type}` : ``
      const Rank = filterDatas?.rank ? `&rank=${filterDatas?.rank}` : ``
      const RankSign = filterDatas?.rankSign
        ? `&ranksign=${decodeURIComponent(filterDatas?.rankSign)}`
        : ``
      const Search = searchRoleValue
        ? `&rolename=${searchRoleValue?.toLocaleLowerCase()}`
        : ``
      const CreatedAtEnd = createdAtEnd ? `&createdAtEnd=${createdAtEnd}` : ``
      const AppendDate = appenddate ? `&appenddate=${appenddate}` : ``
      const CreatedAtStart = createdAtStart
        ? `&createdAtStart=${createdAtStart}`
        : ``
      const Sort = sortBy?.sortName ? `&sort=${sortBy.sortName}` : ``
      const OrderBy = sortBy?.orderBy ? `&orderBy=${sortBy.orderBy}` : ``
      const response = await corporateRequest.get(
        `${BASE_URL}?size=${pageSize}&page=${
          pageNumber - 1
        }${Search}${Round}${Type}${Tier}${City}${Sort}${OrderBy}${Corp}${Role}${College}${Offered}${Accepted}${CreatedAtStart}${CreatedAtEnd}${AppendDate}${Rank}${RankSign}`
      )
      if (excel) {
        dispatch(setExcelData(response?.data?.data || []))
      } else {
        dispatch(setHiringLevel(response?.data?.data || []))
      }

      if (setLoadingRole) setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        dispatch(setExcelData([]))
        setLoadingRole(false)
      }
    }
  }

export const interviewDetails =
  (
    pageSize,
    pageNumber,
    setLoadingRole,
    searchRoleValue,
    filterDatas,
    sortBy,
    excel = false
  ) =>
  async (dispatch, getState) => {
    const state = getState()
    if (setLoadingRole) {
      setLoadingRole(true)
    }
    const corporateId = selector.getCorporateId(state)
    dispatch(setExcelData([]))
    let BASE_URL = 'corporates-reports/candidateinterviewschedule/lists'
    try {
      let tier = encodeURIComponent(filterDatas?.tier || '')
      let city = encodeURIComponent(filterDatas?.city || '')
      let college = encodeURIComponent(filterDatas?.college || '')
      let role = encodeURIComponent(filterDatas?.role || '')
      let offered = encodeURIComponent(filterDatas?.offered || '')
      let accepted = encodeURIComponent(filterDatas?.accepted || '')
      let round = encodeURIComponent(filterDatas?.round || '')
      let type = encodeURIComponent(filterDatas?.type || '')
      let createdAtEnd = filterDatas?.createdAtEnd || ''
      let createdAtStart = filterDatas?.createdAtStart || ''
      let appenddate = filterDatas?.appenddate || ''
      const Corp = `&corpid=${corporateId}`
      const Tier = tier ? `&tier=${tier}` : ``
      const City = city ? `&city=${city}` : ``
      const Offered = offered ? `&offered=${offered}` : ``
      const Accepted = accepted ? `&accepted=${accepted}` : ``
      const College = college ? `&college=${college}` : ``
      const Role = role ? `&role=${role}` : ``
      const Round = round ? `&round=${round}` : ``
      const Type = type ? `&course=${type}` : ``
      const Rank = filterDatas?.rank ? `&rank=${filterDatas?.rank}` : ``
      const RankSign = filterDatas?.rankSign
        ? `&ranksign=${decodeURIComponent(filterDatas?.rankSign)}`
        : ``
      const Search = searchRoleValue
        ? `&rolename=${searchRoleValue?.toLocaleLowerCase()}`
        : ``
      const CreatedAtEnd = createdAtEnd ? `&createdAtEnd=${createdAtEnd}` : ``
      const AppendDate = appenddate ? `&appenddate=${appenddate}` : ``
      const CreatedAtStart = createdAtStart
        ? `&createdAtStart=${createdAtStart}`
        : ``
      const Sort = sortBy?.sortName ? `&sort=${sortBy.sortName}` : ``
      const OrderBy = sortBy?.orderBy ? `&orderBy=${sortBy.orderBy}` : ``
      const response = await corporateRequest.get(
        `${BASE_URL}?size=${pageSize}&page=${
          pageNumber - 1
        }${Search}${Round}${Type}${Tier}${City}${Sort}${OrderBy}${Corp}${Role}${College}${Offered}${Accepted}${CreatedAtStart}${CreatedAtEnd}${AppendDate}${Rank}${RankSign}`
      )
      if (excel) {
        dispatch(setExcelData(response?.data?.data || []))
      } else {
        dispatch(setInterviewSchedule(response?.data?.data || []))
      }

      if (setLoadingRole) setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        dispatch(setExcelData([]))
        setLoadingRole(false)
      }
    }
  }
